import { useTheme } from '@emotion/react';
import { Button, Dialog, DialogActions, Stack, Typography } from '@mui/material';
import React from 'react';
import FormTextField from '../../../../components/FormTextField';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  remarks: yup.string('Remarks').required().min(3, 'Remarks must be at least 3 characters').max(500, 'Remarks Notes must be at most 500 characters').nullable(),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '528px',
    margin: '8px',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100% - 20px)',
  },
};

export default function AcceptAndRejectDialog({ modelOpen, onModelHandleClose, type, data }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const text = theme.palette.primary.text;

  const {t} = useTranslation()

  const handleAcceptReject = async (values) => {
    dispatch(setLoading(true));
    let payload = {
      ...values,
      quoteStatus: type === 'reject' ? 'rejected' : type === 'accept' ? 'accepted' : null,
    };
    const response = await appapi.put(`trader/quoteAcceptOrReject/${data?._id}`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        showmessage(data?.message);
        onModelHandleClose(true);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack className="p-[24px]">
        <Typography
          className="fs-16 ff-Roboto fw-medium"
          color={text}
        >
          {type === 'reject' ? t('Confirm Rejection') : t('Confirm Acceptance')}
        </Typography>
        <Typography
          className="fs-14 ff-Roboto fw-regular !mt-[10px]"
          color={text}
        >
          {type === 'reject' ?  t('Are you sure you want to reject?') : t('Are you sure you want to accept?')}
        </Typography>
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            remarks: '',
            quoteStatus: type === 'reject' ? 'rejected' : data?.quoteStatus === 'accept' ? 'accepted' : null,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleAcceptReject(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
            <Form autoComplete="off">
              <Stack style={{ width: '480px', marginTop: '20px' }}>
                <FormTextField
                  name="remarks"
                  outlineLabel={t('Remark')}
                  multiline={true}
                  maxRows={3}
                  requiredMark={true}
                  inputProps={{ maxLength: 500 }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      minHeight: '72px !important',
                      display: 'block',
                    },
                  }}
                />
              </Stack>
              <DialogActions
                className="!justify-end"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      textTransform: 'uppercase',
                      '&:hover': {},
                    },
                  ]}
                  style={{ width: '112px', height: '48px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      textTransform:'uppercase',
                      backgroundColor: type === 'accept' ? '#00A632' : '#CF1010',
                      '&:hover': {
                        backgroundColor: type === 'accept' ? '#00A632' : '#CF1010',
                      },
                    },
                  ]}
                  style={{ width: '112px', height: '48px' }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {type === 'reject' ? t(`Reject`) : t('Approve')}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
